import { GoogleOAuth } from "./Google";

export default GoogleOAuth;